// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"0d596b13","773":"dac4869d"}[chunkId] + ".chunk.css";
};